import { usePathname, useRouter } from 'expo-router';
import { useCallback } from 'react';
import type { PhotoCaption } from './image-viewer.types';

/**
 * Builds the lightbox caption's press handler: close the viewer, then open the
 * check-in the photo belongs to. Returns undefined for a caption with no
 * check-in, so the caption renders as plain (non-pressable) text.
 *
 * When the viewer was opened from that check-in's own screen, closing is
 * enough; pushing the same screen again would stack a duplicate.
 */
export function useCheckInCaptionPress(
  onClose: () => void
): (caption: PhotoCaption | undefined) => (() => void) | undefined {
  const router = useRouter();
  const pathname = usePathname();

  return useCallback(
    (caption) => {
      const checkInId = caption?.checkInId;
      if (!checkInId) {
        return undefined;
      }
      return () => {
        onClose();
        if (pathname !== `/check-in/${checkInId}`) {
          router.push({ pathname: '/(root)/check-in/[id]', params: { id: checkInId } });
        }
      };
    },
    [onClose, pathname, router]
  );
}
